import { useCallback, useEffect, useState } from 'react';
import { APP_BUILD } from '../lib/appBuild';

const POLL_MS = 3 * 60_000;

async function fetchRemoteBuild(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { v?: unknown };
    return typeof data.v === 'string' && data.v ? data.v : null;
  } catch {
    return null;
  }
}

/** Détecte un nouveau build déployé pendant qu’un onglet reste ouvert. */
export function useClientUpdateCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const check = useCallback(async () => {
    if (updateAvailable) return;
    const remote = await fetchRemoteBuild();
    if (remote && remote !== APP_BUILD) {
      setUpdateAvailable(true);
    }
  }, [updateAvailable]);

  useEffect(() => {
    void check();
    const id = window.setInterval(() => void check(), POLL_MS);
    const onVis = () => {
      if (document.visibilityState === 'visible') void check();
    };
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('focus', onVis);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('focus', onVis);
    };
  }, [check]);

  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  return { updateAvailable, reload };
}
